const API_BASE = '/api';

async function request(path, { method = 'GET', body, token } = {}) {
  const headers = {};
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (token) headers['Authorization'] = `Bearer ${token}`;

  let res;
  try {
    res = await fetch(`${API_BASE}${path}`, {
      method,
      headers,
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new Error('Unable to reach the server. Is the backend running?');
  }

  let data = null;
  try {
    data = await res.json();
  } catch {
    // Non-JSON response; fall through to status handling.
  }

  if (!res.ok) {
    const message = (data && data.error) || `Request failed with status ${res.status}`;
    const error = new Error(message);
    error.status = res.status;
    throw error;
  }

  return data;
}

export const authApi = {
  register: (payload) => request('/auth/register', { method: 'POST', body: payload }),
  login: (payload) => request('/auth/login', { method: 'POST', body: payload }),
  me: (token) => request('/auth/me', { token }),
};

export const notesApi = {
  list: (token) => request('/notes', { token }),
  get: (id, token) => request(`/notes/${id}`, { token }),
  create: (title, token) => request('/notes', { method: 'POST', body: { title }, token }),
  update: (id, title, token) => request(`/notes/${id}`, { method: 'PATCH', body: { title }, token }),
  remove: (id, token) => request(`/notes/${id}`, { method: 'DELETE', token }),
};

export const blocksApi = {
  create: (payload, token) => request('/blocks', { method: 'POST', body: payload, token }),
  update: (id, payload, token) => request(`/blocks/${id}`, { method: 'PATCH', body: payload, token }),
  remove: (id, token) => request(`/blocks/${id}`, { method: 'DELETE', token }),
};
